import {
	SET_QUOTATION_ACTIVE_BILLING,
	SET_QUOTATION_ACTIVE_SHIPPING,
	SET_QUOTATION_CANCELLED,
	SET_QUOTATION_CART,
	SET_QUOTATION_CURRENCY,
	SET_QUOTATION_FREE_DELIVERY,
	SET_QUOTATION_GST_WAIVED,
	SET_QUOTATION_LAST_CONTACT,
	SET_QUOTATION_PAYMENT_OBJECT,
	SET_QUOTATION_PAYMENT_TERM_DAYS,
	SET_QUOTATION_PRODUCTS,
	SET_QUOTATION_USER,
	SET_QUOTATION_USER_NEW_ADDRESS,
  SET_QUOTATION_ENTERPRISE
} from './types';

export const setQuotationActiveBilling = ( address ) => ({
	type: SET_QUOTATION_ACTIVE_BILLING,
	address
});

export const setQuotationActiveShipping = ( address ) => ({
	type: SET_QUOTATION_ACTIVE_SHIPPING,
	address
})

export const setQuotationCancelled = ( cancelledBy ) => ({
	type: SET_QUOTATION_CANCELLED,
	cancelledBy
})

export const setQuotationCart = ( cart ) => ({
  type: SET_QUOTATION_CART,
  cart
})

export const setQuotationCurrency = ( currency ) => ({
	type: SET_QUOTATION_CURRENCY,
	currency
})

export const setQuotationEnterprise = (enterprise) => ({
  type: SET_QUOTATION_ENTERPRISE,
  enterprise
})

export const setQuotationFreeDelivery = ( checked ) => ({
	type: SET_QUOTATION_FREE_DELIVERY,
	checked
})

export const setQuotationGstWaived = ( checked ) => ({
	type: SET_QUOTATION_GST_WAIVED,
	checked
})

export const setQuotationLastContact = ( lastContact ) => ({
	type: SET_QUOTATION_LAST_CONTACT,
	lastContact
})

export const setQuotationPaymentObject = ( payment ) => ({
	type: SET_QUOTATION_PAYMENT_OBJECT,
	payment
})

export const setQuotationPaymentTermDays = ( paymentTermDays ) => ({
	type: SET_QUOTATION_PAYMENT_TERM_DAYS,
	paymentTermDays
})

export const setQuotationProducts = ( products ) => ({
	type: SET_QUOTATION_PRODUCTS,
	products
})

export const setQuotationUser = ( user ) => ({
  type: SET_QUOTATION_USER,
  user
})

export const setQuotationUserNewAddress = ( address ) => ({
	type: SET_QUOTATION_USER_NEW_ADDRESS,
	address
})


// WEBPACK FOOTER //
// ./src/components/quotation/actions.js